import orderInstance from '../instance'

const registerPreOrders = (orderId) => {
	return orderInstance.post('/orders/register', {})
}

export default registerPreOrders
